import * as CryptoJS from 'crypto-js';

export class CryptoService {
  static cryptAsSHA256(stringToCrypt: string){
      return CryptoJS.SHA256(stringToCrypt);
  }
}
